import { Coins, Crown, Receipt, Info } from '@phosphor-icons/react';
import { AmountObject } from '~/services/pay';

export const retryCount = 5;

export const navItems = [
  {
    href: '#rechargeVip',
    _Icon: Crown,
    text: 'VIP充值',
  },
  {
    href: '#rechargePlugin',
    _Icon: Coins,
    text: '积分充值',
  },
  {
    href: '#consumption',
    _Icon: Receipt,
    text: '消费明细',
  },
  {
    href: '#pricing',
    _Icon: Info,
    text: '计费标准',
  },
];

export const amountArr: AmountObject[] = [ {
  key: 'CUSTOM',
  value: 200
}, {
  key: 'PLUGIN_20',
  value: 20
}, {
  key: 'PLUGIN_50',
  bonus: 3,
  value: 50
}, {
  key: 'PLUGIN_100',
  bonus: 8,
  value: 100
}, {
  key: 'PLUGIN_200',
  bonus: 20,
  value: 200
}, {
  key: 'PLUGIN_500',
  bonus: 75,
  value: 500
}, {
  key: 'PLUGIN_1000',
  bonus: 200,
  value: 1000
}];
